<template>
    <div class="maintenance_box">
        <p class="maintenance_title">{{ generalLabel.MAINTENANCE_TITLE }}</p>
        <p class="maintenance_text">{{ generalLabel.MAINTENANCE_MESSAGE_1 }}<br>{{ generalLabel.MAINTENANCE_MESSAGE_2 }}</p>
    </div>
</template>

<script>
import generalLabel from "../properties/general_page/generalpage-labels.json" ;
export default {
  name: "Maintenance",
  created() {
    document.title = generalLabel.MAINTENANCE_PAGE_TITLE;
  },
  data() {
    return {
      generalLabel: generalLabel
    }
  }
};
</script>
<style scoped>
body {
    background-color: #fff;
    font-family: 'Hiragino Kaku Gothic Pro', 'ヒラギノ角ゴ Pro W3', Meiryo, メイリオ, Osaka, 'MS PGothic', arial, helvetica, sans-serif;
}
.maintenance_box {
    margin: 160px 16px auto;
    color: #333;
}
.maintenance_title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 40px;
}
.maintenance_text {
    font-size: 14px;
    line-height: 2;
}
@media (min-width: 414px) {
    .maintenance_box {
        text-align: center;
    }
    .maintenance_title {
        font-size: 24px;
    }
    .maintenance_text {
        font-size: 16px;
    }
}
</style>